import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    helpTopic: "",
    orderNumber: "",
    message: "",
  });

  const [showOrderNumber, setShowOrderNumber] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const handleHelpTopicChange = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      helpTopic: value,
      orderNumber: "", // Reset order number when topic changes
    });

    // Show order number field for specific topics
    const requiresOrderNumber = [
      "Order",
      "Custom Order",
      "Shipping",
      "Returns",
    ].includes(value);
    setShowOrderNumber(requiresOrderNumber);

    if (errors.helpTopic) {
      setErrors({
        ...errors,
        helpTopic: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.helpTopic) {
      newErrors.helpTopic = "Please select a topic";
    }

    if (showOrderNumber && !formData.orderNumber.trim()) {
      newErrors.orderNumber = "Order number is required for this topic";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Form is valid, show success message
      setIsSubmitted(true);

      // Reset form after 3 seconds
      setTimeout(() => {
        setFormData({
          email: "",
          firstName: "",
          lastName: "",
          helpTopic: "",
          orderNumber: "",
          message: "",
        });
        setShowOrderNumber(false);
        setIsSubmitted(false);
        toTop();
      }, 3000);
    }
  };

  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />
        <main id="main" role="main">
          <div
            id="shopify-section-template--17866866982996__main"
            className="shopify-section"
          >
            <div className="Container">
              <header className="PageHeader">
                <div className="SectionHeader SectionHeader--center">
                  <h1 className="SectionHeader__Heading Heading u-h1">
                    Get Help
                  </h1>
                </div>
              </header>
              <div className="PageContent PageContent--narrow">
                <div className="Rte">
                  <div className="row">
                    <meta charSet="utf-8" /> <meta charSet="utf-8" />
                    <p dir="ltr" style={{ textAlign: "left" }}>
                      <meta charSet="utf-8" />
                      We’re here to help 7 days a week from 9am - 9pm EST and
                      aim to respond within 24 hours. In the meantime, our{" "}
                      <Link onClick={toTop} to="/privacy">
                        FAQs
                      </Link>{" "}
                      may help you. You can also contact us by filling out the
                      form below. Adding as much information as possible which
                      will help us assist you more efficiently.
                    </p>
                    <p dir="ltr">
                      We appreciate your patience, and&nbsp;we look forward to
                      helping you soon!
                    </p>
                    <p dir="ltr">
                      Warmly,
                      <br />
                      The Bakimball Customer Care Team
                    </p>
                  </div>
                  <div className="row" />

                  {isSubmitted && (
                    <div
                      className="success-message"
                      style={{
                        padding: "20px",
                        marginBottom: "20px",
                        backgroundColor: "#d4edda",
                        color: "#155724",
                        border: "1px solid #c3e6cb",
                        borderRadius: "4px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        ✓ Thank you! Your message has been sent successfully.
                        We'll get back to you soon!
                      </p>
                    </div>
                  )}

                  <form
                    onSubmit={handleSubmit}
                    id="contact_form"
                    className="Form Form--spacingTight"
                  >
                    <input
                      type="hidden"
                      name="form_type"
                      defaultValue="contact"
                    />
                    <input type="hidden" name="utf8" defaultValue="✓" />
                    <div className="Form__Item">
                      <input
                        className={`Form__Input ${errors.email ? "error" : ""}`}
                        id="contact-email"
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      <label
                        className="Form__FloatingLabel"
                        htmlFor="contact-email"
                      >
                        Email Address
                      </label>
                      {errors.email && (
                        <span
                          className="error-message"
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {errors.email}
                        </span>
                      )}
                    </div>
                    <div className="Form__Group">
                      <div className="Form__Item">
                        <input
                          className={`Form__Input ${
                            errors.firstName ? "error" : ""
                          }`}
                          id="contact-first-name"
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={handleInputChange}
                        />
                        <label
                          className="Form__FloatingLabel"
                          htmlFor="contact-first-name"
                        >
                          First Name
                        </label>
                        {errors.firstName && (
                          <span
                            className="error-message"
                            style={{
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                              display: "block",
                            }}
                          >
                            {errors.firstName}
                          </span>
                        )}
                      </div>
                      <div className="Form__Item">
                        <input
                          className={`Form__Input ${
                            errors.lastName ? "error" : ""
                          }`}
                          id="contact-last-name"
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={formData.lastName}
                          onChange={handleInputChange}
                        />
                        <label
                          className="Form__FloatingLabel"
                          htmlFor="contact-last-name"
                        >
                          Last Name
                        </label>
                        {errors.lastName && (
                          <span
                            className="error-message"
                            style={{
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                              display: "block",
                            }}
                          >
                            {errors.lastName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="Form__Item">
                      <div className="Form__Select Select Select--primary">
                        <svg
                          className="Icon Icon--select-arrow "
                          role="presentation"
                          viewBox="0 0 19 12"
                        >
                          <polyline
                            fill="none"
                            stroke="currentColor"
                            points="17 2 9.5 10 2 2"
                            fillRule="evenodd"
                            strokeWidth={2}
                            strokeLinecap="square"
                          />
                        </svg>
                        <select
                          className={errors.helpTopic ? "error" : ""}
                          id="contact-what-can-we-help-you-with"
                          name="helpTopic"
                          title="What can we help you with?"
                          value={formData.helpTopic}
                          onChange={handleHelpTopicChange}
                        >
                          <option value="">What can we help you with?</option>
                          <option value="Order">Order</option>
                          <option value="Custom Order">Custom Order</option>
                          <option value="Shipping">Shipping</option>
                          <option value="Returns">Returns</option>
                          <option value="Product Questions">
                            Product Questions
                          </option>
                          <option value="General Inquiries">
                            General Inquiries
                          </option>
                        </select>
                      </div>
                      {errors.helpTopic && (
                        <span
                          className="error-message"
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {errors.helpTopic}
                        </span>
                      )}
                    </div>
                    {showOrderNumber && (
                      <div className="Form__Item">
                        <input
                          className={`Form__Input ${
                            errors.orderNumber ? "error" : ""
                          }`}
                          id="contact-order-number"
                          name="orderNumber"
                          type="text"
                          placeholder="Order Number"
                          value={formData.orderNumber}
                          onChange={handleInputChange}
                        />
                        <label
                          htmlFor="contact-order-number"
                          className="Form__FloatingLabel"
                        >
                          Order Number
                        </label>
                        {errors.orderNumber && (
                          <span
                            className="error-message"
                            style={{
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                              display: "block",
                            }}
                          >
                            {errors.orderNumber}
                          </span>
                        )}
                      </div>
                    )}
                    <div className="Form__Item">
                      <textarea
                        className={`Form__Textarea ${
                          errors.message ? "error" : ""
                        }`}
                        id="contact-body-message"
                        name="message"
                        cols={30}
                        rows={10}
                        placeholder="Your message and details here :)"
                        value={formData.message}
                        onChange={handleInputChange}
                      />
                      {errors.message && (
                        <span
                          className="error-message"
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {errors.message}
                        </span>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="Form__Submit Button Button--primary Button--full"
                    >
                      Send message
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default Contact;
